import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Button,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Nav, TabContent, TabPane, NavItem,
} from 'reactstrap';
import { Card, CardBody, CardTitle, NavLink } from 'reactstrap';
// import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { gAPI_Services, API_Ingetration_Channels, postAPI_Update_Services_DisplayOrder, gAPI_Service_CategoryList, postAPI_Update_Services_CategoryDisplayOrder } from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ServiceListItem from './components/ServiceListItem';
import AddNewService from './components/AddNewService';
import CategoryTag from './components/CategoryTag';
import IntlMessages from '../../../../../helpers/IntlMessages';
import TemplateServiceButton from './components/TemplateServiceButton';
import LanguageTabs from '../components/LanguageTabs/LanguageTabs';
import EventCalendar from '../EventCalendar';
import AddonsAndUpsells_image from '../../../../../assets/addons_and_upsells.png';
import guest_book_image from '../../../../../assets/pre-arrival-in-stay-guest-book.png';
import business_operator_guide from '../../../../../assets/business_operator_guide.png';
import ReactDragListView from "react-drag-listview";
import { List, Typography } from "antd";
import "antd/dist/reset.css";
import Select from 'react-select';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CategoryList from './components/Categorylist';
const style_css = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
  top:auto !important;
  bottom: 0 !important;
}
.active{
  background-color:transparent;
}`;
function Index({ propertyId, locale, domains }) {
  const [selectedLanguage, setSelectedLanguage] = useState(locale);
  const [serviceList, setServicesList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingCategory, setLoadingCategory] = useState(true);
  const [visible, setVisible] = useState(false);
  const [orderBy, setOrderBy] = useState({ column: 'Title', label: 'Title' });
  const [search, setSearch] = useState('');
  const [isHostedPage, setIsHostedPage] = useState(false);
  const [allAddonCategoryData, setAllAddonCategoryData] = useState([]);
  const [allMembershipGroupData, setAllMembershipGroupData] = useState([]);
  const [isEditCategory, setIsEditCategory] = useState(false);
  const [activeTab, setActiveTab] = useState('items');
  const [isEventAdd, setIsEventAdd] = useState(false);
  const [isFiltering, setIsFiltering] = useState(false);
  const [fullServiceList, setFullServiceList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState({ value: "Active", label: "Active" });
  const statusList = [
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" },
    { label: "Draft", value: "Draft" },
    { label: "Archive", value: "Archieve" },
  ]

  const orderOptions = [
    { column: 'Title', label: 'Title' },
    { column: 'Type', label: 'Type' },
    { column: 'Response', label: 'Response' },
    { column: 'Status', label: 'Status' },
  ];
  useEffect(() => {
    LoadData(selectedLanguage);
    let body = {
      channels: ['ServiceStandAlonePage']
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration_Channels}?group_id=${getGroupID()}`,
      data: body
    }).then((res) => {
      const serviceHostedPageIntegration = res.data.filter(
        (k) => k.channel === 'ServiceStandAlonePage' && k.properties !== undefined && k.properties.includes(propertyId)
      );
      if (serviceHostedPageIntegration.length > 0)
        setIsHostedPage(true);
    });
  }, [propertyId, orderBy, search, selectedLanguage, selectedStatus]);


  const LoadData = (lang) => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Services}?propertyId=${propertyId}&groupId=${getGroupID()}&lang=${lang}&orderBy=${orderBy.column}&search=${search}`,
    })
      .then((res) => {
        let service = res.data.sort((a, b) => a.displayOrder - b.displayOrder);
        // setServicesList(service);
        setFullServiceList(service);
        setServicesList(service.filter(s => s.status === 'Active'));

        let member = allMembershipGroupData;
        service.map((m) => {
          if (m.membershipGroup !== null && m.membershipGroup.length > 0)
            m.membershipGroup.map((n) => {
              if (member.filter((f) => f === n).length === 0)
                member.push(n);
            })
        }
        );
        setAllMembershipGroupData(member);
        setLoading(false);
      })
      .catch((err) => console.log('err', err));

    AxiosAPI({
      method: 'get',
      url: `${gAPI_Service_CategoryList}?groupId=${getGroupID()}&propertyId=${propertyId}`,
    }).then((res) => {
      var list = res.data.filter(i => i.languageCode === lang).sort((a, b) => a.displayOrder - b.displayOrder);
      setAllAddonCategoryData(list);
      setLoadingCategory(false);
    });
  };
  console.log('service', serviceList)
  const setLanguage = (e) => {
    setLoading(true);
    var lan = e;
    if (e === "zh-TW") {
      lan = "hk";
    }
    setSelectedLanguage(lan);
    LoadData(lan);
    setLoading(false);
    setLoadingCategory(false);
  }

  const toggleModal = () => {
    setVisible(!visible);
  };

  const changeOrderBy = (column) => {
    setOrderBy(orderOptions.find((x) => x.column === column));
  };

  const handleSubmitClick = () => {
    const selectedValue = selectedStatus?.value;
    const filtered = fullServiceList.filter((service) =>
      service.status === selectedValue
    );
    setServicesList(filtered);
    setIsFiltering(false);
  };

  const onSearchKey = (e) => {
    if (e.key === 'Enter') {
      setSearch(e.target.value.toLowerCase());
    }
  };

  if (loading) {
    return <div className="loading" />;
  }
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onDragEnd = (fromIndex, toIndex, type, index) => {
    if (toIndex < 0) return;
    if (type === "LIST-ITEM") {
      const categories = reorder(serviceList, fromIndex, toIndex);
      var data = [];
      categories.map((item, i) => {
        data.push({
          id: item.id,
          displayOrder: i
        })
      });
      AxiosAPI({
        method: 'post',
        url: `${postAPI_Update_Services_DisplayOrder}`,
        data: { data: data },
      }).then((res) => {
        return setServicesList(categories);
      }).catch((err) => {
        console.log('err', err);
      });
    } else return new Error("NOT A VALID LIST");
  };

  const onDragEndCategory = (fromIndex, toIndex, type, index) => {
    if (toIndex < 0) return;
    if (type === "LIST-ITEM") {
      const categories = reorder(allAddonCategoryData, fromIndex, toIndex);
      var data = [];
      categories.map((item, i) => {
        data.push({
          id: item.id,
          displayOrder: i
        })
      });
      AxiosAPI({
        method: 'post',
        url: `${postAPI_Update_Services_CategoryDisplayOrder}`,
        data: { data: data },
      }).then((res) => {
        return setAllAddonCategoryData(categories);
      }).catch((err) => {
        console.log('err', err);
      });
    } else return new Error("NOT A VALID LIST");
  }

  const toggleMenu = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <Fragment>
      <Nav tabs className="card-header-tabs separator-tabs mb-3 ml-0 mr-0">

        <style>{style_css}</style>
        <NavItem className="text-center" style={{ width: 'auto', background: '' }}>
          <NavLink
            style={{ background: 'none', cursor: 'pointer' }}
            to="#"
            location={{}}
            className={classnames({
              active: activeTab === 'items',
              'nav-link': true,
            })}
            onClick={() => toggleMenu('items')}
          >
            <span
              style={{ color: `${activeTab === "items" ? 'var(--theme-color-1)' : '#8f8f8f'}` }}
            >
              Content Items
            </span>
          </NavLink>
        </NavItem>
        <NavItem className="text-center" style={{ width: 'auto', background: '' }}>
          <NavLink
            style={{ background: 'none', cursor: 'pointer' }}
            to="#"
            location={{}}
            className={classnames({
              active: activeTab === 'category',
              'nav-link': true,
            })}
            onClick={() => toggleMenu('category')}
          >
            <span
              style={{ color: `${activeTab === "category" ? 'var(--theme-color-1)' : '#8f8f8f'}` }}
            >
              Categories
            </span>
          </NavLink>
        </NavItem>
        <NavItem className="text-center" style={{ width: 'auto', background: '' }}>
          <NavLink
            style={{ background: 'none', cursor: 'pointer' }}
            to="#"
            location={{}}
            className={classnames({
              active: activeTab === 'menu',
              'nav-link': true,
            })}
            onClick={() => toggleMenu('menu')}
          >
            <span
              style={{ color: `${activeTab === "menu" ? 'var(--theme-color-1)' : '#8f8f8f'}` }}
            >
              Menu
            </span>
          </NavLink>
        </NavItem>
        <NavItem className="text-center" style={{ width: 'auto', background: '' }}>
          <NavLink
            style={{ background: 'none', cursor: 'pointer' }}
            to="#"
            location={{}}
            className={classnames({
              active: activeTab === 'events',
              'nav-link': true,
            })}
            onClick={() => toggleMenu('events')}
          >
            <span
              style={{ color: `${activeTab === "events" ? 'var(--theme-color-1)' : '#8f8f8f'}` }}
            >
              Events Calendar
            </span>
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="items">
          <Row className="app-row survey-app">
            <Colxx xxs="12">
              <div className="mt-2">
                <div className="d-block d-md-inline-block">
                  <div className=" d-inline-block  ">
                    <Button
                      size="xs"
                      color="primary"
                      className=""
                      onClick={() => setIsFiltering(!isFiltering)}
                    >
                      <div className='d-flex'>
                        <FontAwesomeIcon icon={faFilter} className="fa mr-1 mt-1" />
                        <IntlMessages id="menu.show-filter" />
                        <div className='ml-1' style={{ marginTop: "2px" }}>
                          {isFiltering ?
                            <i className='simple-icon-arrow-up p-1'></i> :
                            <i className='simple-icon-arrow-down p-1'></i>
                          }
                        </div>
                      </div>
                    </Button>
                  </div>
                  <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                    <DropdownToggle caret color="outline-dark" size="xs">
                      <IntlMessages id="pages.orderby" />
                      {orderBy.label}
                    </DropdownToggle>
                    <DropdownMenu>
                      {orderOptions.map((order, index) => {
                        return (
                          <DropdownItem
                            key={index}
                            onClick={() => changeOrderBy(order.column)}
                          >
                            {order.label}
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                  <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                    <input
                      type="text"
                      name="keyword"
                      id="search"
                      placeholder="Search"
                      onKeyPress={(e) => onSearchKey(e)}
                    />
                  </div>
                  {!loading && (
                    <Fragment>
                      <div className="text-zero top-right-button-container ml-2">
                        <Button
                          color="primary"
                          size="xs"
                          className="top-right-button mr-1"
                          onClick={toggleModal}
                          outline
                        >
                          + Add New
                        </Button>
                        {(domains !== null && domains.length > 0 && domains[0].type !== undefined && domains.filter((f) => f.type === 'BusinessOperator').length > 0) ? null :
                          <TemplateServiceButton LoadData={LoadData} isServiceOrder={false} languageCode={selectedLanguage} />}
                      </div>
                    </Fragment>
                  )}
                  {locale && locale === 'en' && <a href="/app/pages/propinfo/publish-ai">
                    <Button
                      color="primary"
                      outline
                      className='ml-2'
                      size="xs"
                    >
                      Publish AI
                    </Button>
                  </a>}
                </div>
              </div>
            </Colxx>
            <Colxx xxs="12" className="mb-2">
              <LanguageTabs
                selectedTab={selectedLanguage === "hk" ? "zh-TW" : selectedLanguage}
                setLanguage={setLanguage}
              ></LanguageTabs>
            </Colxx>
          </Row>
          {/* <Separator className="mb-5" /> */}
          {!loading ? (
            serviceList.length > 0 ?
              <div>
                <Card className="d-flex flex-row " style={{ borderRadius: '10px', backgroundColor: 'var(--theme-color-2)', marginBottom: '20px' }}>
                  <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                    <div className="card-body align-self-center d-flex flex-column flex-lg-row text-white" style={{ marginTop: '4px' }}>
                      <p className="mb-1 ml-5 text-small font-weight-bold w-15 w-sm-100"></p>
                      <p className="mb-1 text-small font-weight-bold  text-left w-12 w-sm-100 pl-2">Title</p>
                      <p className="mb-1 text-small font-weight-bold text-left w-10 w-sm-100">Type</p>
                      <p className="mb-1 text-small font-weight-bold text-left  w-18 w-sm-100">Highlights</p>
                      <p className="mb-1 text-small font-weight-bold text-left w-10 w-sm-100">Category</p>
                      <p className="mb-1 text-small font-weight-bold text-left w-10 w-sm-100">Price Range</p>
                      <p className="mb-1 text-small font-weight-bold text-left w-10 w-sm-100">Status</p>

                      <p className="mb-1 text-small font-weight-bold w-10 w-sm-100"></p>
                    </div>
                  </div>
                </Card>
                <ReactDragListView
                  nodeSelector=".ant-list.draggable"
                  lineClassName="dragLine"
                  onDragEnd={(fromIndex, toIndex) =>
                    onDragEnd(fromIndex, toIndex, "LIST-ITEM")
                  }
                >
                  {serviceList.map((elem, index) => (
                    <List key={index} className="draggable">
                      <div className="d-flex flex-row mb-3">
                        <span className="draggable item-center mb-3"><a href="#"><i className="simple-icon-cursor-move"></i></a></span>
                        <ServiceListItem
                          item={elem}
                          toggleModal={toggleModal}
                          isHostedPage={isHostedPage}
                          isServiceOrder={false}
                          allAddonCategoryData={allAddonCategoryData}
                          allMembershipGroupData={allMembershipGroupData}
                          LoadData={LoadData}
                          languageCode={selectedLanguage}
                        />
                      </div>
                    </List>
                  ))}
                </ReactDragListView>
              </div>
              : (
                <Fragment>
                  <Colxx xxs="12" className="mb-0 text-center">
                    {(domains !== null && domains.length > 0 && domains[0].type !== undefined && domains.filter((f) => f.type === 'BusinessOperator').length > 0) ?
                      <img className='w-30' style={{ marginTop: '5rem' }} alt="Addons And Upsells" src={business_operator_guide}></img> :
                      <img className='w-30' style={{ marginTop: '5rem' }} alt="Addons And Upsells" src={guest_book_image}></img>}</Colxx>
                  <Colxx xxs="12" className="mb-4 text-center">

                    <Button
                      color="primary"
                      size="xs"
                      className="top-right-button mr-2"
                      onClick={toggleModal}
                      outline
                    >
                      + Add New
                    </Button>
                    {(domains !== null && domains.length > 0 && domains[0].type !== undefined && domains.filter((f) => f.type === 'BusinessOperator').length > 0) ? null :
                      <TemplateServiceButton LoadData={LoadData} languageCode={selectedLanguage} />}
                  </Colxx>
                </Fragment>
              )
          ) : (
            <div className="loading" />
          )}
          {isFiltering && (
            <Card className="filter-width mt-2" style={{ position: "absolute", zIndex: "1", top: "10rem", marginLeft: "8rem", boxShadow: "0 1px 20px 20px rgb(0 0 0 / 4%), 0 1px 6px rgb(0 0 0 / 4%)" }}>
              <CardBody >

                <Colxx md="12" >
                  <Row>

                    <Colxx xxs="12" md="12" className=" mb-2">
                      <Select
                        isMulti={false}
                        className="react-select"
                        classNamePrefix="react-select"
                        name="status"
                        placeholder="Select Status"
                        onChange={(selected) => setSelectedStatus(selected)}
                        options={statusList}
                        value={selectedStatus}
                      />

                    </Colxx>

                    <Colxx xxs="12" md="12">
                      <Button
                        size="xs"
                        color="primary"
                        className="mb-2 mt-2"
                        onClick={handleSubmitClick}
                      >
                        Search
                      </Button>
                      <Button
                        size="xs"
                        color="secondary"
                        className="mb-2 ml-2 mt-2"
                        onClick={() => setIsFiltering(false)}
                      >
                        Cancel
                      </Button>

                    </Colxx>
                  </Row>
                </Colxx>
              </CardBody>
            </Card>
          )}
        </TabPane>
      </TabContent>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="category">
          <Row className="app-row survey-app mb-4">
            <Colxx xxs="12">
              <div className="mb-1 mt-2">
                <Button
                  color="primary"
                  size="xs"
                  outline
                  className="top-right-button mr-1"
                  onClick={() => setIsEditCategory(true)}
                >
                  + Add New <IntlMessages id="survey.category" />
                </Button>
              </div>
            </Colxx>
          </Row>
          {/* <Separator className="mb-5" /> */}
          {!loadingCategory ? (
            allAddonCategoryData.length > 0 ?
              <ReactDragListView
                nodeSelector=".ant-list.draggable"
                lineClassName="dragLine"
                onDragEnd={(fromIndex, toIndex) =>
                  onDragEndCategory(fromIndex, toIndex, "LIST-ITEM")
                }
              >
                {allAddonCategoryData.map((elem, index) => (
                  <List key={index} className="draggable">
                    <div className="d-flex flex-row mb-3">
                      <span className=" draggable item-center mb-3"><a href="#"><i className="simple-icon-cursor-move"></i></a></span>
                      <CategoryList
                        item={elem}
                        allAddonCategoryData={allAddonCategoryData}
                        propertyId={propertyId}
                        LoadData={LoadData}
                        languageCode={selectedLanguage}
                      />
                    </div>
                  </List>
                ))}
              </ReactDragListView>
              : (
                <Fragment>
                  <div style={{
                    position: 'absolute',
                    left: '40%',
                    padding: "10px"
                  }}>
                    <div>
                      <img
                        src={guest_book_image}
                        alt="Addons And Upsells"
                        style={{ maxWidth: '400px', position: "relative", }}
                      />
                    </div>
                    <div style={{
                      position: "relative",
                      // bottom: "60px",
                      padding: "10px", textAlign: "center"
                    }}>
                      <Button
                        color="primary"
                        size="xs"
                        outline
                        className="top-right-button mr-1"
                        onClick={() => setIsEditCategory(true)}
                      >
                        + Add New <IntlMessages id="survey.category" />
                      </Button>
                    </div>
                  </div>
                </Fragment>
              )
          ) : (
            <div className="loading" />
          )}
        </TabPane>
      </TabContent>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="menu">

          <div style={{
            position: 'absolute',
            left: '45%',
            padding: "10px",
            top: "50%",
          }}>
            <div style={{
              position: "relative", fontSize: "20px", padding: "10px", textAlign: "center"
            }}>
              <span>Coming Soon</span>
            </div>
          </div>
        </TabPane>
      </TabContent>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="events">
          <EventCalendar
            isEvent={isEventAdd}
          ></EventCalendar>
        </TabPane>
      </TabContent>
      <AddNewService
        toggleModal={toggleModal}
        formLabel="Create"
        visible={visible}
        allAddonCategoryData={allAddonCategoryData}
        allMembershipGroupData={allMembershipGroupData}
        LoadData={LoadData}
        languageCode={selectedLanguage}
      />
      {isEditCategory && (
        <CategoryTag
          visible={isEditCategory}
          toggle={() => setIsEditCategory(!isEditCategory)}
          allCategoryData={allAddonCategoryData}
          isEdit={false}
          propertyId={propertyId}
          LoadData={LoadData}
          languageCode={selectedLanguage}
        ></CategoryTag>
      )}
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, domains } = settings;
  return {
    propertyId,
    locale,
    domains
  };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
